import { BrandType } from '../models/request-and-responses/rest-api/enums/brandType';

export interface IBrandObject {
    value: BrandType;
    label: string;
}

export const BrandObjects: IBrandObject[] = [
    { value: BrandType.Ajo, label: 'AJO (PATAVIUM BRAND)' },
    { value: BrandType.Patavium, label: 'PATAVIUM' },
    { value: BrandType.UniEnergia, label: `UNIENERGIA` },
    { value: BrandType.AjoEnergia, label: `AJO ENERGIA` }
];



// WEBPACK FOOTER //
// ./src/app/helpers/brandObjects.ts